<template>
    <div>
        <v-label v-if="label">
            {{ label }}
        </v-label>
        <v-text-field
            solo
            v-bind:value="value"
            @click="colorMenu = true"
            :error-messages="this.errorMessages"
            @blur="$emit('blur', $event)"
        >
            <template v-slot:append>
                <v-menu
                    v-model="colorMenu"
                    top
                    nudge-top="40"
                    nudge-left="16"
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle" v-on="on" />
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker
                                @input="$emit('input', $event)"
                                :value="value"
                                flat
                                mode="hexa"
                                ref="colorPicker"
                            />
                        </v-card-text>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
        },
        label: {
            type: String,
        },
        errorMessages: {
            type: Array,
        },
    },

    data() {
        return {
            colorMenu: false,
        }
    },

    computed: {
        defaultColor() {
            return '#000000'
        },
        swatchStyle() {
            const color = this.value
            const menu = this.colorMenu

            return {
                backgroundColor: color,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: menu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out',
            }
        },
    },

    created() {
        if (!this.value) {
            this.$emit('input', this.defaultColor)
        }
    },
}
</script>

<style></style>
